import { useState } from 'react';

export const usePasswordToggler = () => {
  const [isPasswordVisible, togglePasswordVisibility] = useState(false);

  const onShowPasswordClick = () => {
    togglePasswordVisibility(!isPasswordVisible);
  };

  const passwordInputType = isPasswordVisible ? 'text' : 'password';
  return { onShowPasswordClick, isPasswordVisible, passwordInputType };
};
